module.exports = __webpack_public_path__ + "img/fire-ic.e48e4548.gif";